import React from 'react';
import { Route, Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import WalletListCard from '@/components/WithdrawManage/WalletListCard';
import WalletManage from '@/components/WithdrawManage/WalletManage';
import Nav from "@/components/Nav";
import './style.less';

const { Sider, Content } = Layout;
const clsPrefix = 'WithdrawMoneyPage'

const getSelectedKeyByRoute = () => {
  let currentRoute = window.location.pathname;
  let selectedKey = null;
  switch (currentRoute) {
    case "/v5/withdraw":
      selectedKey = ["1"];
      break;

    case "/v5/withdraw/kzcoin":
      selectedKey = ["2"];
      break;

    default:
      selectedKey = ["1"];
      break;
  }
  return selectedKey;
};

const WithdrawMoneyPage = ({ match }) => (
  <React.Fragment>
    <Nav />
    <Layout style={{ maxHeight: "0"}}>
      <Sider className={`${clsPrefix}-sider`} theme="light">
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={getSelectedKeyByRoute()}
        >
          <Menu.Item key="1">
            <Link to="/v5/withdraw">现金钱包</Link>
          </Menu.Item>
          <Menu.Item key="2">
            <Link to="/v5/withdraw/kzcoin">快币钱包</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Content className={`${clsPrefix}-content`}>
        <CashWithdrawPage match={match} />
      </Content>
    </Layout>
  </React.Fragment>
);

const Kzcoin = () => (
  <iframe style={{ border: 'none' }} height="1080px" width="1300px" src="https://www.kuaizhan.com/kzcoin/wallet" title="kzcoin" />
)

const CashWithdrawPage = ({ match }) => (
  <div>
    <Route exact path={`${match.url}`} component={WalletListCard} />
    <Route path={`${match.url}/walletManage`} component={WalletManage}/>
    <Route path={`${match.url}/kzcoin`} component={Kzcoin}/>
  </div>
)

export default WithdrawMoneyPage;